module.exports = __webpack_public_path__ + "img/moren.c7353f71.jpeg";